import NetworkApi from "../../data/network/NetworkApi";
import NetworkApiImpl from "../../data/network/NetworkApiImpl";
import { AuthRepository } from "../../data/repository/auth/AuthRepository";
import { AuthRepositoryImpl } from "../../data/repository/auth/AuthRepositoryImpl";
import { CategoryRepository } from "../../data/repository/category/CategoryRepository";
import { CategoryRepositoryImpl } from "../../data/repository/category/CategoryRepositoryImpl";
import { CustomerRepository } from "../../data/repository/customer/CustomerRepository";
import { CustomerRepositoryImpl } from "../../data/repository/customer/CustomerRepositoryImpl";
import {
  LoginUseCase,
  LoginUseCaseImpl,
} from "../../domain/usecase/auth/Login/LoginUseCase";
import {
  GetAllCustomersUseCase,
  GetAllCustomersUseCaseImpl,
} from "../../domain/usecase/customer/getAll/UseCase";
import {
  SearchCustomersUseCase,
  SearchCustomersUseCaseImpl,
} from "../../domain/usecase/customer/search/UseCase";
import {
  CreateCategoryUseCase,
  CreateCategoryUseCaseImpl,
} from "../../domain/usecase/category/create/CreateUseCase";
import {
  DeleteCategoryUseCase,
  DeleteCategoryUseCaseImpl,
} from "../../domain/usecase/category/delete/DeleteUseCase";
import {
  GetCategoryUseCase,
  GetCategoryUseCaseImpl,
} from "../../domain/usecase/category/get/GetUseCase";
import {
  GetAllCategoriesUseCase,
  GetAllCategoriesUseCaseImpl,
} from "../../domain/usecase/category/getAll/GetAllUseCase";
import { provideApiBuilder } from "./NetworkModule";
import {
  UpdateCategoryUseCase,
  UpdateCategoryUseCaseImpl,
} from "../../domain/usecase/category/update/UpdateUseCase";
import { UploadFileRepository } from "../../data/repository/uploadFIle/UploadFileRepository";
import { UploadFileRepositoryImpl } from "../../data/repository/uploadFIle/UploadFileRepositoryImpl";
import {
  UploadFileUseCase,
  UploadFileUseCaseImpl,
} from "../../domain/usecase/uploadFile/UploadFileUseCase";
import {
  UploadMultipleFilesUseCase,
  UploadMultipleFilesUseCaseImpl,
} from "../../domain/usecase/uploadFile/UploadMultipleFilesUseCase";
import { ProductRepository } from "../../data/repository/product/ProductRepository";
import { ProductRepositoryImpl } from "../../data/repository/product/ProductRepositoryImpl";
import {
  GetAllProductsUseCase,
  GetAllProductsUseCaseImpl,
} from "../../domain/usecase/product/getAll/GetAllUseCase";
import {
  DeleteProductUseCase,
  DeleteProductUseCaseImpl,
} from "../../domain/usecase/product/delete/DeleteUseCase";
import {
  UpdateProductUseCase,
  UpdateProductUseCaseImpl,
} from "../../domain/usecase/product/update/UpdateUseCase";
import {
  GetProductUseCase,
  GetProductUseCaseImpl,
} from "../../domain/usecase/product/get/GetUseCase";
import {
  CreateProductUseCase,
  CreateProductUseCaseImpl,
} from "../../domain/usecase/product/create/CreateUseCase";
import {
  GetCustomerByIdUseCase,
  GetCustomerByIdUseCaseImpl,
} from "../../domain/usecase/customer/getById/UseCase";
import {
  GetCustomerOrdersUseCase,
  GetCustomerOrdersUseCaseImpl,
} from "../../domain/usecase/customer/getOrders/UseCase";
import { OrderRepository } from "../../data/repository/order/OrderRepository";
import { OrderRepositoryImpl } from "../../data/repository/order/OrderRepositoryImpl";
import {
  GetAllOrdersUseCase,
  GetAllOrdersUseCaseImpl,
} from "../../domain/usecase/order/getAll/UseCase";
import {
  GetOrderByIdUseCase,
  GetOrderByIdUseCaseImpl,
} from "../../domain/usecase/order/getById/UseCase";
import { TransactionRepository } from "../../data/repository/transactions/TransactionRepository";
import { TransactionRepositoryImpl } from "../../data/repository/transactions/TransactionRepositoryImpl";
import {
  GetAllTransactionsUseCase,
  GetAllTransactionsUseCaseImpl,
} from "../../domain/usecase/transaction/getAll/UseCase";
import {
  UpdateOrderUseCase,
  UpdateOrderUseCaseImpl,
} from "../../domain/usecase/order/update/UseCase";
import { ReportRepository } from "../../data/repository/report/ReportRepository";
import { ReportRepositoryImpl } from "../../data/repository/report/ReportRepositoryImpl";
import {
  GetPerProductReportUseCase,
  GetPerProductReportUseCaseImpl,
} from "../../domain/usecase/report/getPerProduct/UseCase";
import {
  GetPerStoreReportUseCase,
  GetPerStoreReportUseCaseImpl,
} from "../../domain/usecase/report/getPerStore/UseCase";
import { StoreRepository } from "../../data/repository/store/StoreRepository";
import { StoreRepositoryImpl } from "../../data/repository/store/StoreRepositoryImpl";
import {
  GetAllStoresUseCase,
  GetAllStoresUseCaseImpl,
} from "../../domain/usecase/store/getAll/GetAllUseCase";
import {
  CreateStoreUseCase,
  CreateStoreUseCaseImpl,
} from "../../domain/usecase/store/create/CreateUseCase";
import {
  GetStoreUseCase,
  GetStoreUseCaseImpl,
} from "../../domain/usecase/store/get/GetUseCase";
import {
  UpdateStoreUseCase,
  UpdateStoreUseCaseImpl,
} from "../../domain/usecase/store/update/UpdateUseCase";
import {
  DeleteStoreUseCase,
  DeleteStoreUseCaseImpl,
} from "../../domain/usecase/store/delete/DeleteUseCase";
import { DownloadOrderReceiptCase, DownloadOrderReceiptCaseImpl } from "../../domain/usecase/order/downloadReceipt/UseCase";
import { DownloadMultipleOrderReceiptsCase, DownloadMultipleOrderReceiptsCaseImpl } from "../../domain/usecase/order/downloadMultipleReceipts/UseCase";
import { GetDeliveryPriceUseCase, GetDeliveryPriceUseCaseImpl } from "../../domain/usecase/product/getDeliveryPrice/UseCase";
import { EditDeliveryPriceUseCase, EditDeliveryPriceUseCaseImpl } from "../../domain/usecase/product/editDeliveryPrice/UseCase";

function provideNetworkApi(): NetworkApi {
  return new NetworkApiImpl(provideApiBuilder());
}

// auth
function provideAuthRepository(): AuthRepository {
  return new AuthRepositoryImpl(provideNetworkApi());
}
export function provideLoginUseCase(): LoginUseCase {
  return new LoginUseCaseImpl(provideAuthRepository());
}

// upload file
function provideUploadImageRepository(): UploadFileRepository {
  return new UploadFileRepositoryImpl(provideNetworkApi());
}
export function provideUploadFileUseCase(): UploadFileUseCase {
  return new UploadFileUseCaseImpl(provideUploadImageRepository());
}
export function provideUploadMultipleFilesUseCase(): UploadMultipleFilesUseCase {
  return new UploadMultipleFilesUseCaseImpl(provideUploadImageRepository());
}

// customer
function provideCompanyRepository(): CustomerRepository {
  return new CustomerRepositoryImpl(provideNetworkApi());
}
export function provideGetAllCustomersUseCase(): GetAllCustomersUseCase {
  return new GetAllCustomersUseCaseImpl(provideCompanyRepository());
}
export function provideGetCustomerByIdUseCase(): GetCustomerByIdUseCase {
  return new GetCustomerByIdUseCaseImpl(provideCompanyRepository());
}
export function provideSearchCustomersUseCase(): SearchCustomersUseCase {
  return new SearchCustomersUseCaseImpl(provideCompanyRepository());
}
export function provideGetCustomerOrdersUseCase(): GetCustomerOrdersUseCase {
  return new GetCustomerOrdersUseCaseImpl(provideCompanyRepository());
}

// category
function provideCategoryRepository(): CategoryRepository {
  return new CategoryRepositoryImpl(provideNetworkApi());
}
export function provideGetAllCategoriesUseCase(): GetAllCategoriesUseCase {
  return new GetAllCategoriesUseCaseImpl(provideCategoryRepository());
}
export function provideCreateCategoryUseCase(): CreateCategoryUseCase {
  return new CreateCategoryUseCaseImpl(provideCategoryRepository());
}
export function provideGetCategoryUseCase(): GetCategoryUseCase {
  return new GetCategoryUseCaseImpl(provideCategoryRepository());
}
export function provideUpdateCategoryUseCase(): UpdateCategoryUseCase {
  return new UpdateCategoryUseCaseImpl(provideCategoryRepository());
}
export function provideDeleteCategoryUseCase(): DeleteCategoryUseCase {
  return new DeleteCategoryUseCaseImpl(provideCategoryRepository());
}

// store
function provideStoreRepository(): StoreRepository {
  return new StoreRepositoryImpl(provideNetworkApi());
}
export function provideGetAllStoresUseCase(): GetAllStoresUseCase {
  return new GetAllStoresUseCaseImpl(provideStoreRepository());
}
export function provideCreateStoreUseCase(): CreateStoreUseCase {
  return new CreateStoreUseCaseImpl(provideStoreRepository());
}
export function provideGetStoreUseCase(): GetStoreUseCase {
  return new GetStoreUseCaseImpl(provideStoreRepository());
}
export function provideUpdateStoreUseCase(): UpdateStoreUseCase {
  return new UpdateStoreUseCaseImpl(provideStoreRepository());
}
export function provideDeleteStoreUseCase(): DeleteStoreUseCase {
  return new DeleteStoreUseCaseImpl(provideStoreRepository());
}

// product
function provideProductRepository(): ProductRepository {
  return new ProductRepositoryImpl(provideNetworkApi());
}
export function provideGetAllProductsUseCase(): GetAllProductsUseCase {
  return new GetAllProductsUseCaseImpl(provideProductRepository());
}
export function provideCreateProductUseCase(): CreateProductUseCase {
  return new CreateProductUseCaseImpl(provideProductRepository());
}
export function provideGetProductUseCase(): GetProductUseCase {
  return new GetProductUseCaseImpl(provideProductRepository());
}
export function provideUpdateProductUseCase(): UpdateProductUseCase {
  return new UpdateProductUseCaseImpl(provideProductRepository());
}
export function provideDeleteProductUseCase(): DeleteProductUseCase {
  return new DeleteProductUseCaseImpl(provideProductRepository());
}
export function provideGetDeliveryPriceUseCase(): GetDeliveryPriceUseCase {
  return new GetDeliveryPriceUseCaseImpl(provideProductRepository());
}
export function provideEditDeliveryPriceUseCase(): EditDeliveryPriceUseCase {
  return new EditDeliveryPriceUseCaseImpl(provideProductRepository());
}

// order
function provideOrderRepository(): OrderRepository {
  return new OrderRepositoryImpl(provideNetworkApi());
}
export function provideGetAllOrdersUseCase(): GetAllOrdersUseCase {
  return new GetAllOrdersUseCaseImpl(provideOrderRepository());
}
export function provideGetOrderByIdUseCase(): GetOrderByIdUseCase {
  return new GetOrderByIdUseCaseImpl(provideOrderRepository());
}
export function provideUpdateOrderUseCase(): UpdateOrderUseCase {
  return new UpdateOrderUseCaseImpl(provideOrderRepository());
}
export function provideDownloadOrderReceiptUseCase(): DownloadOrderReceiptCase {
  return new DownloadOrderReceiptCaseImpl(provideOrderRepository());
}
export function provideDownloadMultipleOrderReceiptsUseCase(): DownloadMultipleOrderReceiptsCase {
  return new DownloadMultipleOrderReceiptsCaseImpl(provideOrderRepository());
}

// transaction
function provideTransactionRepository(): TransactionRepository {
  return new TransactionRepositoryImpl(provideNetworkApi());
}
export function provideGetAllTransactionsUseCase(): GetAllTransactionsUseCase {
  return new GetAllTransactionsUseCaseImpl(provideTransactionRepository());
}

// report
function provideReportRepository(): ReportRepository {
  return new ReportRepositoryImpl(provideNetworkApi());
}
export function provideGetPerProductReportUseCase(): GetPerProductReportUseCase {
  return new GetPerProductReportUseCaseImpl(provideReportRepository());
}
export function provideGetPerStoreReportUseCase(): GetPerStoreReportUseCase {
  return new GetPerStoreReportUseCaseImpl(provideReportRepository());
}
